// @mui
import { enUS, itIT } from "@mui/material/locale";

// MULTI LANGUAGES
// Please remove `localStorage` when you change settings.

export const allLangs = [
  {
    label: "Italiano",
    value: "it",
    systemValue: itIT,
    icon: "/flags/ic_flag_it.svg",
  },
  {
    label: "English",
    value: "en",
    systemValue: enUS,
    icon: "/flags/ic_flag_en.svg",
  },
];

export const defaultLang = allLangs[1]; //imposta qui la lingua di default
